<template>
  <div :class="col">
    <div
      :class="'alert ' + (alertType.startsWith('alert-') ? alertType : 'alert-' + alertType)"
      role="alert"
      :style="'margin-bottom: ' + marginbottom"
    >
      <b v-if="header">{{header}}&nbsp;</b>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    col: {
      type: String,
      default: 'col-lg-12'
    },
    header: {
      type: String,
      default: 'Uwaga!'
    },
    marginbottom: {
      type: String,
      default: '20px'
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>